/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
import PropTypes from 'prop-types';
import {
    useState,
    useEffect,
} from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateReasonsLabel } from 'src/utils/getReferralData';
// form
import { useForm, Controller } from 'react-hook-form';
import { useTheme } from '@mui/material/styles';
// @mui
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    FormControl,
    Divider,
    Button,
    FormHelperText,
    ToggleButtonGroup,
    ToggleButton,
    Switch,
} from '@mui/material';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// components
import { useSettingsContext } from 'src/components/settings/context';
import { Iconify } from '.';
import ReminderPresetSelector from './ReminderPresetSelector';
import { ArchivedAutocomplete } from './AutoComplete';
import { FormProvider, RHFTextField } from './hook-form';
// constant
import {
    archiveSelection,
    followUpSelection,
    VISIBLE_CONTACT_METHODS,
    PRIMARY_ARCHIVE_REASONS,
} from '../constants/appointmentReason';
// hooks
// store
import {
    archivedLeadSlice,
    saveNewLeadDetail,
    ArchivedLeadDashBoard,
    tableLead
} from '../redux/slices/lead';
import { updateError } from '../redux/slices/user';
import { useSelector, dispatch } from '../redux/store';
// validation
import { AppointmentPageSchema } from '../validations/validations';
// style
import {
    appointmentNotBooked
} from '../styles/DialogueTabs';
import { onBoardFooterButtonsStyle, footerButtonBoxStyle, nextButtonStyle } from '../styles/DialoguePopup';
import { chipToggleButtonStyle } from '../styles/Common';
import {
    progressBarContainerStyle,
    progressBarTextStyle,
    progressBarTrackStyle,
    progressBarFillStyle,
    statusBadgeDoneStyle,
    statusBadgeOptionalStyle,
    statusBadgeRecommendedStyle,
    successBannerGreenStyle,
    successBannerCheckGreenStyle,
    successBannerTextStyle,
} from '../styles/FailedToAttendTabs';


// ---------------------------------------------------------------------------------------

const AppointmentNotBooked = ({ onClose }) => {
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    const { archivedLead, followLead } = useSelector((state) => state.lead);
    const { archiveReasons, contactMethod } = useSelector((state) => state.schema);
    const settings = useSettingsContext();
    const { enqueueSnackbar } = useSnackbar();
    const [activeTime, setActiveTime] = useState('custom reminder');
    const [followUp, setFollowUP] = useState(null);
    const [isCommunication, setCommunication] = useState(followLead?.openCommunication || 'No');
    const [assignToState, setAssignToState] = useState([]);

    const defaultValues = {
        reason: '',
        OtherNotes: '',
        preferredContactMethod: 'PHONE',
        reminder: '',
        reminderDateTime: null,
        addNote: '',
        archiveNotes: '',
        archived: '',
        otherNotes: '',
        customReminder: 'custom reminder',
        callReminder: ''
    };

    const [newArchiveReasons, setNewArchiveReasons] = useState([]);
    const [showMoreReasons, setShowMoreReasons] = useState(false);
    useEffect(() => {
        if (archiveReasons && archiveReasons.length > 0) {
            const newArchive = archiveReasons.filter((value) => value !== 'UNABLE_TO_CONTACT');
            const archive = newArchive.sort().map((value) => ({ label: value === 'NHS_WAITING_LIST' ? 'NHS waiting list' : value === 'WANT_NHS' ? 'Want NHS' : generateReasonsLabel(value), value }))
            setNewArchiveReasons(archive);
        }
    }, [archiveReasons]);

    // Follow-up chips come from newArchiveReasons (full Note enum — schema.js no
    // longer restricts to BE-archive-only values) filtered by followUpSelection.

    useEffect(() => {
        if (followLead) {
            dispatch(tableLead(followLead));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [followLead]);

    const methods = useForm({
        mode: 'onChange',
        resolver: yupResolver(AppointmentPageSchema),
        defaultValues,
    });

    const {
        control,
        setValue,
        watch,
        getValues,
        handleSubmit,
        clearErrors,
    } = methods;

    const values = watch();

    const onSubmit = (data) => {
        let archiveLead = {};
        const addNotesObj = {
            note: data?.reason,
            additional_notes: data?.callReminder ? data?.OtherNotes : data?.archiveNotes,
        };
        if (data?.preferredContactMethod) {
            addNotesObj.contacted_via = data?.preferredContactMethod && data?.preferredContactMethod;
        }
        const archiveData = {
            note: data?.archiveNotes
        };
        const openCommunication = {
            id: followLead?.id || '',
            is_open_for_communication: isCommunication === 'Yes',
        };
        archiveLead = {
            notes: addNotesObj,
            archiveData,
            callReminder: data?.callReminder,
            customReminder: data?.customReminder,
            openCommunication
        };
        if (activeTime !== '' && data?.customReminder !== 'no-reminder') {
            if (!data?.reminderDateTime && followUp) {
                dispatch(updateError({
                    message: 'Please select tab',
                    status: false
                }));
                return;
            }
            const addReminderObj = {
                note: data?.addNote,
                is_completed: false,
                assignees: assignToState?.map((el) => el?.id),
                group: 'FOLLOW_UP',
            };
            if (data?.reminder) {
                // Defensive uppercase — matches Reminder enum convention (BE PR #5550 normalizes; kept as belt-and-braces).
                addReminderObj.method = data?.reminder?.toUpperCase?.() || data?.reminder;
            }
            if (data?.reminderDateTime) {
                addReminderObj.datetime = `${moment(data?.reminderDateTime).format('DD-MM-YYYY HH:mm:ss')}.0Z`;
            }
            archiveLead = {
                ...archiveLead,
                addReminderObj,
            };
        }
        dispatch(saveNewLeadDetail({
            archiveLead,
        }));
        dispatch(ArchivedLeadDashBoard(
            onClose, followLead
        ));
    };

    const handleChangeCommunication = (event) => {
        setCommunication(event.target.value);
    };


    useEffect(() => {
        if (getValues('reason') !== '') {
            if (getValues('reason') === 'OTHER') {
                setFollowUP(false);
                enqueueSnackbar('Lead will be archived', {
                    variant: 'warning',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    }
                });
                dispatch(archivedLeadSlice(true));
                setValue('archived', true);
                setValue('otherNotes', true);
            }
            if (archiveSelection.includes(getValues('reason'))) {
                setFollowUP(false);
                enqueueSnackbar('Lead will be archived', {
                    variant: 'warning',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    }
                });
                dispatch(archivedLeadSlice(true));
                setValue('archived', true);
                setValue('otherNotes', false);
            }
            if (followUpSelection.includes(getValues('reason'))) {
                dispatch(archivedLeadSlice(false));
                setValue('archived', false);
                setFollowUP(true);
                setValue('otherNotes', false);
            }
            // Fallback: newly-added Note enum values (e.g. SPAM, TREATMENT_RELATED,
            // NOT_INTERESTED) not in archiveSelection or followUpSelection would leave
            // followUp null → 1-step mode, no notes/reminder shown. Default to archive path.
            const reason = getValues('reason');
            if (reason && !followUpSelection.includes(reason) && !archiveSelection.includes(reason) &&
                reason !== 'OTHER') {
                setFollowUP(false);
                dispatch(archivedLeadSlice(true));
                setValue('archived', true);
                setValue('otherNotes', false);
            }
        }
        return () => {
            dispatch(archivedLeadSlice(null));
            setValue('archived', '');
        };
    }, [getValues('reason')]);

    useEffect(() => {
        setValue('customReminder', activeTime);
    }, [activeTime]);

    useEffect(() => {
        if (archivedLead === true) {
            setValue('callReminder', false);
        }
        else {
            setValue('callReminder', true);
        }
    }, [archivedLead]);


    // Progress tracking
    const reasonDone = values.reason !== '';
    const contactMethodDone = values.preferredContactMethod !== '';
    const reminderDone = followUp === true && (activeTime === 'no-reminder' || values.reminderDateTime !== null || (activeTime !== 'custom reminder' && activeTime !== ''));
    const notesDone = followUp === true ? values.OtherNotes !== '' : followUp === false ? values.archiveNotes !== '' : false;

    const getSteps = () => {
        if (followUp === true) return [reasonDone, contactMethodDone, reminderDone, notesDone];
        if (followUp === false) return [reasonDone, contactMethodDone, notesDone];
        return [reasonDone];
    };
    const steps = getSteps();
    const completedCount = steps.filter(Boolean).length;
    const totalSteps = steps.length;
    const progressPercent = totalSteps > 0 ? (completedCount / totalSteps) * 100 : 0;
    // Drop the `&& totalSteps > 1` guard — it prevented Finish from ever turning
    // green on the 1-step path (unrecognized reason values, now handled by the
    // fallback-to-archive fix). Without the guard, the button goes green as soon
    // as every required field is done, regardless of how many steps there are.
    const allComplete = completedCount === totalSteps;

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)} >
            <Card variant="outlined" sx={{ p: 3, borderRadius: 2.5, border: '1px solid', borderColor: 'divider', boxShadow: '0 0 2px rgba(145, 158, 171, 0.2), 0 4px 16px rgba(145, 158, 171, 0.08)' }}>
                {/* Progress bar */}
                <Box sx={progressBarContainerStyle(allComplete ? totalSteps : completedCount)}>
                    <Typography sx={progressBarTextStyle(allComplete ? totalSteps : completedCount)}>{completedCount} of {totalSteps} complete</Typography>
                    <Box sx={progressBarTrackStyle}>
                        <Box sx={progressBarFillStyle(progressPercent)} />
                    </Box>
                </Box>
                <Grid container spacing={1} sx={appointmentNotBooked}>
                    <Controller
                        name="reason"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <FormControl>
                                <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 600, mb: 1, display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    Reason
                                    {reasonDone ? <Box component="span" sx={statusBadgeDoneStyle}>Done</Box> : <Box component="span" sx={statusBadgeRecommendedStyle}>Required</Box>}
                                    {error && !field.value?.length &&
                                        <FormHelperText error sx={{ px: 2 }}>
                                            {error?.message}
                                        </FormHelperText>}
                                </Typography>
                                <Typography sx={{ fontSize: '11px', color: '#919EAB', mb: 0.75, fontWeight: 500 }}>
                                    Follow up
                                </Typography>
                                <ToggleButtonGroup
                                    color="primary"
                                    exclusive
                                    value={field.value}
                                    onChange={(e, value) => {
                                        if (value === null) {
                                            field.onChange('');
                                            return;
                                        }
                                        field.onChange(value);
                                    }}
                                    aria-label="Platform"
                                    sx={{ borderRadius: 0, border: 'none', flexWrap: 'wrap' }}
                                    error={error && !field.value?.length}
                                    defaultValue={values.preferredContactMethod}
                                >
                                    {newArchiveReasons?.filter(reason => reason.value === 'NHS_WAITING_LIST' || followUpSelection.includes(reason.value))?.map((options, index) => (
                                        <ToggleButton
                                            key={index}
                                            value={options.value}
                                            sx={chipToggleButtonStyle(isLight)}
                                        >
                                            {field.value === options.value && <Iconify icon='bi:check' width={13} height={13} sx={{ mr: 0.5 }} />}{options.label}
                                        </ToggleButton>
                                    ))}
                                </ToggleButtonGroup>
                                <Typography sx={{ fontSize: '11px', color: '#919EAB', mt: 1.25, mb: 0.75, fontWeight: 500 }}>
                                    Archive reasons
                                </Typography>
                                <ToggleButtonGroup
                                    color="primary"
                                    exclusive
                                    value={field.value}
                                    onChange={(e, value) => {
                                        if (value === null) {
                                            field.onChange('');
                                            return;
                                        }
                                        field.onChange(value);
                                    }}
                                    aria-label="Platform"
                                    sx={{ borderRadius: 0, border: 'none', flexWrap: 'wrap' }}
                                    error={error && !field.value?.length}
                                    defaultValue={values.preferredContactMethod}
                                >
                                    {newArchiveReasons?.filter(reason => reason.value !== 'NHS_WAITING_LIST' && !followUpSelection.includes(reason.value) && PRIMARY_ARCHIVE_REASONS.includes(reason.value))
                                        ?.sort((a, b) => PRIMARY_ARCHIVE_REASONS.indexOf(a.value) - PRIMARY_ARCHIVE_REASONS.indexOf(b.value))
                                        ?.map((options, index) => (
                                        <ToggleButton
                                            key={index}
                                            value={options.value}
                                            sx={chipToggleButtonStyle(isLight)}
                                        >
                                            {field.value === options.value && <Iconify icon='bi:check' width={13} height={13} sx={{ mr: 0.5 }} />}{options.label}
                                        </ToggleButton>
                                    ))}
                                </ToggleButtonGroup>
                                {!showMoreReasons && newArchiveReasons?.some(reason => reason.value !== 'NHS_WAITING_LIST' && !followUpSelection.includes(reason.value) && !PRIMARY_ARCHIVE_REASONS.includes(reason.value)) && (
                                    <Box
                                        onClick={() => setShowMoreReasons(true)}
                                        sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', mt: 0.5, color: '#919EAB', fontSize: '12px', fontWeight: 500, '&:hover': { color: '#637381' } }}
                                    >
                                        <Iconify icon='eva:more-horizontal-fill' width={16} height={16} sx={{ mr: 0.5 }} /> More reasons
                                    </Box>
                                )}
                                {showMoreReasons && (
                                    <ToggleButtonGroup
                                        color="primary"
                                        exclusive
                                        value={field.value}
                                        onChange={(e, value) => {
                                            if (value === null) {
                                                field.onChange('');
                                                return;
                                            }
                                            field.onChange(value);
                                        }}
                                        aria-label="Platform"
                                        sx={{ borderRadius: 0, border: 'none', flexWrap: 'wrap', mt: 0.5 }}
                                        error={error && !field.value?.length}
                                    >
                                        {newArchiveReasons?.filter(reason => reason.value !== 'NHS_WAITING_LIST' && !followUpSelection.includes(reason.value) && !PRIMARY_ARCHIVE_REASONS.includes(reason.value))?.map((options, index) => (
                                            <ToggleButton
                                                key={index}
                                                value={options.value}
                                                sx={chipToggleButtonStyle(isLight)}
                                            >
                                                {field.value === options.value && <Iconify icon='bi:check' width={13} height={13} sx={{ mr: 0.5 }} />}{options.label}
                                            </ToggleButton>
                                        ))}
                                    </ToggleButtonGroup>
                                )}

                            </FormControl>
                        )}
                    />
                </Grid>
                {reasonDone && (
                    <Box sx={successBannerGreenStyle}>
                        <Box sx={successBannerCheckGreenStyle}>
                            <Iconify icon="eva:checkmark-fill" width={14} height={14} sx={{ color: '#fff' }} />
                        </Box>
                        <Typography sx={successBannerTextStyle}>
                            Reason selected: {generateReasonsLabel(values.reason)}
                        </Typography>
                    </Box>
                )}
                {followUp === false && <Box
                    sx={{
                        display: 'block',
                        mb: 3,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Notes</Typography>
                        {notesDone ? <Box component="span" sx={statusBadgeDoneStyle}>Done</Box> : <Box component="span" sx={statusBadgeRecommendedStyle}>Recommended</Box>}
                    </Box>
                    <RHFTextField
                        sx={{ width: '100%' }}
                        name='archiveNotes'
                        multiline
                        rows={4}
                        label='Archive notes (Required)'
                        placeholder='Add note here'
                    />
                </Box>
                }
                {
                    followUp !== true && <Box sx={{ pt: 3, borderTop: 'solid 1px rgba(145, 158, 171, 0.2)', '.MuiFormControl-root': { width: '100%' } }}>
                        <Controller
                            name="preferredContactMethod"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <FormControl>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ fontWeight: 600, mb: 1.5, display: 'flex', alignItems: 'center', gap: '8px' }}
                                    >
                                        Method of contact
                                        {contactMethodDone && <Box component="span" sx={statusBadgeDoneStyle}>Done</Box>}
                                    </Typography>
                                    <ToggleButtonGroup
                                        color="primary"
                                        exclusive
                                        value={field.value}
                                        onChange={(e, value) => {
                                            if (value === null) {
                                                field.onChange('');
                                                return;
                                            }
                                            field.onChange(value);
                                        }}
                                        aria-label="Platform"
                                        sx={{ borderRadius: 0, border: 'none', flexWrap: 'wrap' }}
                                        error={error && !field.value?.length}
                                        defaultValue={values.preferredContactMethod}
                                    >
                                        {contactMethod?.filter(opt => VISIBLE_CONTACT_METHODS.includes(opt.value))?.map((options, index) => (
                                            <ToggleButton
                                                key={index}
                                                value={options.value}
                                                sx={chipToggleButtonStyle(isLight)}
                                            >
                                                {field.value === options.value && <Iconify icon='bi:check' width={13} height={13} sx={{ mr: 0.5 }} />}{options.label}
                                            </ToggleButton>
                                        ))}
                                    </ToggleButtonGroup>
                                    {error && !field.value?.length &&
                                        <FormHelperText error sx={{ px: 2, textTransform: 'capitalize' }}>
                                            {error?.message}
                                        </FormHelperText>}
                                </FormControl>
                            )}
                        />
                    </Box>
                }
                <Box
                    sx={{
                        display: 'none',
                        mb: '40px',
                    }}
                >
                    <RHFTextField sx={{ width: '100%' }} name='OtherNotes' multiline rows={4} label='Additional notes (Required)' />
                </Box>
                {followUp === true ? <>
                    <ReminderPresetSelector
                        control={control}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        activeTime={activeTime}
                        onPresetChange={(val) => { setActiveTime(val); setValue('customReminder', val); }}
                        assignToState={assignToState}
                        setAssignTo={setAssignToState}
                        showStepBadges={false}
                    />
 </> : ''}
                {followUp === true && <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Notes</Typography>
                        {notesDone ? <Box component="span" sx={statusBadgeDoneStyle}>Done</Box> : <Box component="span" sx={statusBadgeOptionalStyle}>Optional</Box>}
                    </Box>
                    <RHFTextField name="OtherNotes" multiline rows={4} label="Additional notes" InputLabelProps={{ shrink: true }} placeholder='Add notes here' />
                </Box>}
                {
                    followUp === true && <Box sx={{ pt: 3, borderTop: 'solid 1px rgba(145, 158, 171, 0.2)', '.MuiFormControl-root': { width: '100%' } }}>
                        <Controller
                            name="preferredContactMethod"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <FormControl>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ fontWeight: 600, mb: 1.5, display: 'flex', alignItems: 'center', gap: '8px' }}
                                    >
                                        Method of contact
                                        {contactMethodDone && <Box component="span" sx={statusBadgeDoneStyle}>Done</Box>}
                                    </Typography>
                                    <ToggleButtonGroup
                                        color="primary"
                                        exclusive
                                        value={field.value}
                                        onChange={(e, value) => {
                                            if (value === null) {
                                                field.onChange('');
                                                return;
                                            }
                                            field.onChange(value);
                                        }}
                                        aria-label="Platform"
                                        sx={{ borderRadius: 0, border: 'none', flexWrap: 'wrap' }}
                                        error={error && !field.value?.length}
                                        defaultValue={values.preferredContactMethod}
                                    >
                                        {contactMethod?.filter(opt => VISIBLE_CONTACT_METHODS.includes(opt.value))?.map((options, index) => (
                                            <ToggleButton
                                                key={index}
                                                value={options.value}
                                                sx={chipToggleButtonStyle(isLight)}
                                            >
                                                {field.value === options.value && <Iconify icon='bi:check' width={13} height={13} sx={{ mr: 0.5 }} />}{options.label}
                                            </ToggleButton>
                                        ))}
                                    </ToggleButtonGroup>
                                    {error && !field.value?.length &&
                                        <FormHelperText error sx={{ px: 2, textTransform: 'capitalize' }}>
                                            {error?.message}
                                        </FormHelperText>}
                                </FormControl>
                            )}
                        />
                    </Box>
                }
                {followUp === false &&
                    <>
                        <Divider sx={{ mt: 3 }} />
                        <Box sx={{ py: 3 }} >
                            <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600, mb: 1 }}
                            >
                                Is this person open to being contacted in the future?
                            </Typography>
                            No <Switch
                                name='isCommunication'
                                checked={isCommunication}
                                onChange={handleChangeCommunication}
                                inputProps={{ 'aria-label': 'controlled' }}
                            /> Yes
                        </Box>
                        <Divider sx={{ mb: 3 }} />
                        <Box sx={{ mt: '15px' }}>
                            <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600, mb: 1.5 }}
                            >
                                Tags
                            </Typography>
                            <ArchivedAutocomplete type={'table'} user={followLead} />
                        </Box>
                    </>}
            </Card>
            <Box className="buttons-box" sx={footerButtonBoxStyle}>
                <Container
                    maxWidth={settings.themeStretch ? false : 'xl'}
                    sx={onBoardFooterButtonsStyle()}
                    className="buttons-container"
                >
                    <Button
                        color="primary"
                        variant={allComplete ? 'contained' : 'outlined'}
                        type="submit"
                        className="finish-button"
                        sx={allComplete ? {
                            ...nextButtonStyle(),
                            background: '#00AB55',
                            color: '#fff',
                            borderColor: '#00AB55',
                            '&:hover': { background: '#007B55', borderColor: '#007B55' },
                        } : nextButtonStyle()}
                    >
                        {allComplete && <Iconify icon="eva:checkmark-fill" width={18} height={18} sx={{ mr: 0.5 }} />}
                        {archivedLead ? 'Archive' : 'Finish'}
                    </Button>
                </Container>
            </Box>
        </FormProvider >
    );
};

AppointmentNotBooked.propTypes = {
    onClose: PropTypes.any
};

export default AppointmentNotBooked;
